import { ResourceStore } from 'src/stores/ResourceStore/ResourceStore';

export const CountryResourceStore = new ResourceStore('data/country.json');
